var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 8.66668C13.3334 11.9953 9.64075 15.462 8.40075 16.5327C8.28523 16.6195 8.14461 16.6665 8.00008 16.6665C7.85555 16.6665 7.71493 16.6195 7.59941 16.5327C6.35941 15.462 2.66675 11.9953 2.66675 8.66668C2.66675 7.25219 3.22865 5.89563 4.22885 4.89544C5.22904 3.89525 6.58559 3.33334 8.00008 3.33334C9.41457 3.33334 10.7711 3.89525 11.7713 4.89544C12.7715 5.89563 13.3334 7.25219 13.3334 8.66668Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6667C9.10457 10.6667 10 9.77123 10 8.66666C10 7.56209 9.10457 6.66666 8 6.66666C6.89543 6.66666 6 7.56209 6 8.66666C6 9.77123 6.89543 10.6667 8 10.6667Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_1161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c5e403c668e768f5daa7d1e862835826.svg";
export { ForwardRef as ReactComponent };